module.exports = __webpack_public_path__ + "img/video.7e3c5bf2.jpg";